<template>
  <div class="editPage">
    <qx-card :title="pageTitle">
      <BaseForm
        ref="baseForm"
        @getOtherFormVal="getOtherFormVal"
        @getRechargeAccount="getRechargeAccount"
      />
      <Receipt ref="receipt" @getOtherFormVal="getOtherFormVal" />
    </qx-card>
    <SubBtnBox @sub="sub" />
  </div>
</template>

<script>
import BaseForm from './base';
import Receipt from './receipt';
import SubBtnBox from 'components/subBtnBox';
import {
  manageEdit,
  manageDetail,
} from 'api/cost';
import pageDataMixin from '@qx/mixin/pageData';
export default {
  mixins: [
    pageDataMixin,
  ],
  components: {
    BaseForm,
    Receipt,
    SubBtnBox,
  },
  data () {
    return {
      pageUrl: '/manage/cost/manage/edit',
      formComponents: ['baseForm', 'receipt'],
    };
  },
  computed: {
    detailParams () {
      return {
        payId: this.$route.query.id,
        // expireDate
      };
    },
  },
  methods: {
    detailApi: manageDetail,
    editApi: manageEdit,
    async getOtherFormVal ({ from, tar }) {
      const tarFormData = await this.$refs[tar].cacheData();
      this.$refs[from].receiveData(tar, tarFormData);
    },
    getRechargeAccount () {
      this.$refs.receipt.getRechargeAccount();
    },
  },
  async mounted () {
    await this.$refs.baseForm.getList();
    this.getData();
  },
};
</script>

<style scoped lang="scss">
</style>
